
import { Component, Vue } from 'vue-property-decorator'
import cardModule from '@/store/card'
import cardListEditor from '@/components/company/cardList/CardListEditor.vue'
import { DefaultCardList } from '../../../utils/enums'

@Component({
  name: 'CardListDetail',
  components: {
    cardListEditor
  }
})
class CardListDetail extends Vue {
  private get cardList() {
    return cardModule.cardList
  }

  private async created(): Promise<void> {
    await cardModule.fetchCardList(this.$route.params.cid)
  }

  private isFeaturedCardList(): boolean {
    return this.cardList?.name === DefaultCardList.NAME
  }

  private get formattedName() {
    if (!this.isFeaturedCardList()) {
      return this.cardList?.name
    }

    return 'Featured 🌟'
  }
}

export default CardListDetail
